module.exports = __webpack_public_path__ + "static/media/sub-card-label-7.c742d6e3.svg";